export const formatWithThousandsSeparator = (value: number, decimalPlaces = 2): string =>{
  const numberParts = value.toFixed(decimalPlaces).toString().split('.');
  numberParts[0] = numberParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return numberParts.join('.');
};